export default [
  {
    label: "Tabelas",
    icon: "fas fa-cog",
    items: [
      {
        label: "Tabela de comissões",
        to: "/registrations/commissions",
        icon: "fas fa-coins",
        controller: "CommissionCompetence",
        action: "List"
      },
      {
        label: "Tabela de taxas",
        to: "/registrations/configuration-taxes",
        icon: "fas fa-percentage",
        controller: "ConfigurationTax",
        action: "List"
      },
      {
        label: "Tabela de tipo de composição",
        to: "/registrations/composition-fee-type",
        icon: "fas fas-solid fa-file-invoice-dollar",
        controller: "CompositionFeeType",
        action: "List"
      },
      {
        label: "Tabela de serviços",
        to: "/registrations/services",
        icon: "fas fa-tags",
        controller: "PaymentMethod",
        action: "List"
      },
      {
        label: "Tabela de tipo de serviço",
        to: "/registrations/service-type",
        icon: "fas fa-inbox",
        controller: "ServiceType",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Tabela de feriados bancários",
        to: "/registrations/holidays",
        icon: "fas fa-calendar-check",
        controller: "Holiday",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Tabela de documentos comerciais",
        to: "/registrations/merchant-doc-types",
        icon: "fas fa-file-alt",
        controller: "MerchantDocType",
        action: "List"
      },
      {
        label: "Tabela de documentos dos parceiros",
        to: "/registrations/partner-doc-types",
        icon: "fas fa-file-invoice",
        controller: "PartnerDocType",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Tabela de países",
        to: "/registrations/countries",
        icon: "fas fa-globe-americas",
        controller: "Country",
        action: "List"
      },
      {
        label: "Tabela de estados",
        to: "/registrations/states",
        icon: "fas fa-map-marked-alt",
        controller: "State",
        action: "List"
      },
      {
        label: "Tabela de cidades",
        to: "/registrations/cities",
        icon: "fas fa-map-marker-alt",
        controller: "City",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Tabela de bancos",
        to: "/registrations/banks",
        icon: "fas fa-university", 
        controller: "Bank",
        action: "List"
      },
      {
        label: "Tabela de agências",
        to: "/registrations/agencies",
        icon: "fas fa-building",
        controller: "Bank",
        action: "List"
      },
      {
        label: "Tabela de gateways",
        to: "/registrations/gateways",
        icon: "fas fa-network-wired",
        controller: "Gateway",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Tabela de tipos de espécies",
        to: "/registrations/specie-types",
        icon: "fas fa-file",
        controller: "SpecieType",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Tabela de nichos",
        to: "/registrations/nichos",
        icon: "fas fa-layer-group",
        isAuthorize: true
      },
      {
        label: "Tabela de segmentos",
        to: "/registrations/segmentos",
        icon: "fas fa-sitemap",
        isAuthorize: true
      }
    ]
  },
  {
    label: "Categorias",
    icon: "fas fa-cog",
    items: [
      {
        label: "Categorias do Atendimento ao Cliente",
        to: "/registrations/customer-service-category",
        icon: "fas fa-users-cog",
        controller: "CustomerServiceCategory",
        action: "List"
      },
      {
        label: "Categorias de Contato",
        to: "/registrations/contact-category",
        icon: "fa-solid fa-address-book",
        controller: "ContactCategory",
        action: "List"
      },
      {
        label: "Categorias do Atendimento ao Parceiro",
        to: "/registrations/parceiro-atendimento-categoria",
        icon: "fas fa-users-cog",
        controller: "ParceiroAtendimentoCategoria",
        action: "List"
      },
      {
        label: "Categorias do Fornecedor",
        to: "/registrations/categorias-dos-fornecedores",
        icon: "fas fa-handshake",
        controller: "CategoriasDosFornecedores",
        action: "List"
      }
    ]
  },
  {
    label: "Bandeiras",
    to: "/registrations/brand",
    icon: "fas fa-flag",
    controller: "Brand",
    action: "List"
  },
  {
    label: "Documentos",
    to: "/registrations/documents",
    icon: "fas fa-file-upload",
    controller: "Document",
    action: "List"
  },
  {
    separator: true
  },
  {
    label: "Tipo de Registros",
    to: "/registrations/register-type",
    icon: "fas fa-file",
    controller: "Answer",
    action: "List"
  },
  {
    separator: true
  },
  {
    label: "Cadastro de Contas Bancárias",
    to: "/registrations/RegistrationsBankAccount",
    icon: "fas fa-university",
    controller: "BankAccount",
    action: "List"
  }
];


// WEBPACK FOOTER //
// ./src/data/menu-item-internal/internal-registry-menu.js